import React, { useEffect } from 'react'
import logo from '../../assets/images/zeeno_logo.png'
import exitIcon from "../../assets/icons/ic_exit.svg"
import NavbarHome from '../NavbarHome'
import { useAtom } from 'jotai'
import { loggedInUser, selectedPage } from '../store/DataStore'
import ActionsFragment from '../fragments/ActionsFragment'
import TasksFragment from '../fragments/TasksFragment'
import MapFragment from '../fragments/MapFragment'
import VideosFragment from '../fragments/VideosFragment'
import UsersFragment from '../fragments/UsersFragment'
import SupportFragment from '../fragments/SupportFragment'
import SettingsFragment from '../fragments/SettingsFragment'
import { collection, getDocs, query, updateDoc, where } from 'firebase/firestore'
import { db } from '../../firebase-config'
import { useNavigate } from 'react-router-dom'
import { currentRobot } from '../store/DataStore';
import { getRobotCapabilities } from '../../lib/robotCapabilities';


function Homepage() {
  const navigate = useNavigate();
  const [selected] = useAtom(selectedPage)
  const [currentUser] = useAtom(loggedInUser);
  const [selectedRobot] = useAtom(currentRobot);

  useEffect(() => {
    document.title = "Zeeno | Home";
    refreshActive(currentUser.email, true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const refreshActive = async (userEmail, value) => {
    console.log('refreshActive called');
    if (!userEmail) {
      console.error('Invalid user email');
      return;
    }

    try {
      const usersCollectionRef = collection(db, 'Companies/Zeeno_Dev/Users');
      const q = query(usersCollectionRef, where("email", "==", userEmail));
      const querySnapshot = await getDocs(q);

      if (querySnapshot.empty) {
        console.log('No user found with the given email');
        return;
      }
      const userDoc = querySnapshot.docs[0];
      const userDocRef = userDoc.ref;

      await updateDoc(userDocRef, {
        isActive: value
      });

      console.log('User lastLogin timestamp updated successfully');
    } catch (error) {
      console.error('Error updating user lastLogin: ', error);
    }
  };

  useEffect(() => {
    if (selected === 7) {
        window.open('https://support.zeenorobotics.com/portal/en/home', '_blank');
    }
}, [selected]);

  const renderContent = () => {
    const capabilities = getRobotCapabilities(selectedRobot);

    switch (selected) {
      case 0: return <ActionsFragment userName={currentUser.name}/>;
      case 1: return <TasksFragment />;
      case 2:
       return capabilities.supportsMap
        ? <MapFragment />
        : <ActionsFragment userName={currentUser.name} />;
      case 3: return <VideosFragment userName={currentUser.name}/>
      case 4: return <UsersFragment userName={currentUser.name}/>
      case 5: return <SupportFragment />
      case 6: return <SettingsFragment userName={currentUser.name} />
      case 7: return <ActionsFragment userName={currentUser.name}/>;

      default: return <ActionsFragment userName={currentUser.name}/>;
    }
  };

  return (
    <div className='flex min-h-screen flex-col overflow-hidden bg-[#F0F2FF] select-none lg:flex-row'>
      <div className='w-full bg-[#3C5BD2] px-4 py-4 lg:w-72 lg:px-0 lg:py-5'>
        <div className='flex items-center justify-between gap-4 lg:block'>
          <div className='lg:px-10'>
            <img src={logo} alt="logo" className='h-8 select-none lg:h-9' />
          </div>
          <div
            className='flex w-fit cursor-pointer items-center rounded-lg bg-[#7685fc] px-3 py-2 lg:hidden'
            onClick={() => {
              refreshActive(currentUser.email, false)
              navigate("/")
            }}
          >
            <img src={exitIcon} alt='exit' className='h-4' />
            <span className='ml-2 max-w-[140px] truncate font-heebo text-sm text-white'>{currentUser.name}</span>
          </div>
        </div>
        <NavbarHome />
        <div className='hidden justify-center lg:flex lg:mt-16 2xl:mt-[300px]'>
          <div className='flex w-fit cursor-pointer items-center rounded-lg bg-[#7685fc] px-5 py-[7px]' onClick={() => {
            refreshActive(currentUser.email, false)
            navigate("/")
          }}>
            <img src={exitIcon} alt='exit' className='h-5' />
            <span className='ml-3 font-heebo text-md text-white'>{currentUser.name}</span>
          </div>
        </div>
      </div>
      <div className='min-w-0 flex-1'>
        {renderContent()}
      </div>
    </div>
  )
}

export default Homepage
